const datasPipe = [ // std->sh->lg
    [15, 0.5, 21.3, 38, 28, 45],
    [20, 0.75, 27, 38, 38, 57.5],
    [25, 1, 33.5, 38, 25, 72.5],
    [32, 1.15, 42.3, 47.6, 32, 92.5],
    [40, 1.5, 48.3, 57.2, 38, 109],
    [50, 2, 60.3, 76.2, 51, 135],
    [65, 2.5, 76.1, 95.4, 64, 175, 73], // 95.8, 95
    [80, 3, 88.9, 114.3, 76, 205],
    [100, 4, 114.3, 152.4, 102, 270],
    [125, 5, 139.7, 190.5, 127, 330, 141], // 191, 190
    [150, 6, 168.3, 228.6, 152, 390],
    [200, 8, 219.1, 304.8, 203, 510],
    [250, 10, 273, 381, 254, 650],
    [300, 12, 323.9, 457, 305, 770],
    [350, 14, 355.6, 533, 356, 850],
    [400, 16, 406.4, 609.6, 406, 970],
    [450, 18, 457, 685.8, 457, 1122],
    [500, 20, 508, 762, 508, 1254],
    [550, 22, 559, 838, 559, 1398],
    [600, 24, 610, 914, 610, 1525],
    [650, 26, 660, 991, 660, 1650],
    [700, 28, 711, 1067, 711, 1778],
    [750, 30, 762, 1143, 762, 1905],
    [800, 32, 814, 1219, 813, 2033],
    [850, 34, 864, 1295, 864, 2155],
    [900, 36, 914, 1372, 914, 2285],
    [950, 38, 965, 1448, 965, 0],
    [1000, 40, 1016, 1524, 1016, 0],
    [1050, 42, 1067, 1600, 1067, 0],
    [1100, 44, 1118, 1676, 1118, 0],
    [1150, 46, 1168, 1753, 1168, 0],
    [1200, 48, 1219, 1829, 1219, 0]
];

export default datasPipe; 